import React, { useEffect, useRef, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  delete_icon,
  dummmyimage,
  dummyimage,
  edit_icon,
  eye_icon,
  green_icon,
  password_icon,
  red_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/imgs";
import { data, useNavigate } from "react-router-dom";
import { admin_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import apiRequest from "../redux/api/apiRequest";
import {
  useCompanyAddMutation,
  useCompanyDeleteMutation,
  useCompanyEditMutation,
  useCompanyListMutation,
  useLazyCompanyListViewQuery,
  useLazyCompanyRolesListQuery,
  useLazyCompanyStatusQuery,
  useLazyLocationListQuery,
} from "../redux/api/api";
import { EMAIL, PASS } from "../redux/api/Constants";
import { toast } from "react-toastify";
import { post } from "../../Services/ApiHandler";
import { URL as ApiCall } from "../../Services/Constant";
import CommonLoader from "../../components/CommonLoader";

const Company = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState("");
  const [id, setID] = useState("");
  const [editMode, setEditMode] = useState(false);
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [deletePopup, setDeletePopup] = useState("");
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [visible, setVisible] = useState(false);
  const [rolesList, setRoleslist] = useState();
  const [locList, setLoclist] = useState([]);
  const [selectedImage, setSelectedImage] = useState();
  const [image, setImage] = useState("");
  const [count, setCount] = useState();
  const [images, setImages] = useState([]);
  const inputRef = useRef(null);
  const inputRefImg = useRef(null);
  const [banner, setBanner] = useState("");
  const [fieldsetEnable, setFiedsetEnable] = useState(true);
  const [emailCheckData, setEmailCheckData] = useState({});
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);
  const [fullLoader, setFullLoader] = useState(false);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(event.target.files[0]);
  };

  const handleImageChangePro = (event) => {
    const file = event.target.files[0];
    setImage(event.target.files[0]);
  };
  const handleImageClick = () => {
    inputRef.current.click();
  };

  const handleImageClickPro = () => {
    inputRefImg.current.click();
  };

  const admindetailsObj = {
    id: "",
    company_name: "",
    company_code: "",
    name: "",
    email: "",
    role_id: "",
    phone: "",
    password: "",
    password_confirmation: "",
    location: "",
    logo: "",
  };

  const [admindetails, setAdminDetails] = useState(admindetailsObj);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [companyList] = useCompanyListMutation();
  const [addCompany] = useCompanyAddMutation();
  const [companyRolesList] = useLazyCompanyRolesListQuery();
  const [companyLocationList] = useLazyLocationListQuery();
  const [adminStatus] = useLazyCompanyStatusQuery();
  const [deleteAdmin] = useCompanyDeleteMutation();
  const [updateAdmin] = useCompanyEditMutation();
  const [companyView] = useLazyCompanyListViewQuery();

  console.log(
    "emailCheckData",
    emailCheckData,
    "emailCheckFlag",
    emailCheckFlag,
    "admindetails",
    admindetails,
  );

  const handleStatus = async (id) => {
    const res = await apiRequest(adminStatus, id);
    if (res?.status == "success") {
      toast.success(res?.message);
      getList();
    }
  };

  const handleDelete = async (id) => {
    const res = await apiRequest(deleteAdmin, id);
    if (res?.status == "success") {
      toast.success(res?.message);
      setDeletePopup("");
      getList();
    }
  };

  function isValidURL(string) {
    var res = string.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    );
    return res !== null;
  }

  const companyListView = async (id, type) => {
    setLoading(true);
    const res = await apiRequest(companyView, id);
    if (res?.status == "success") {
      let data = res?.data;
      setSelectedImage(data?.logo);
      setImage(data?.profile_image);
      let admindetailsObj_ = {
        id: id,
        company_name: data?.company_name ? data?.company_name : "",
        company_code: data?.company_code ? data?.company_code : "",
        name: data?.name ? data?.name : "",
        email: data?.email ? data?.email : "",
        role_id: data?.role_id ? data?.role_id : "",
        phone: data?.phone ? data?.phone : "",
        location: data?.location ? data?.location : "",
        logo: data?.logo ? data?.logo : "",
        profile_image: data?.profile_image ? data?.profile_image : "",
        is_email_verified: data?.is_email_verified,
      };
      setEmailCheckFlag(1);
      setAdminDetails(admindetailsObj_);
      // Object.keys(admindetails).forEach((item) => {
      //   // console.log(item);
      //   setEmailCheckFlag(1);
      //   setAdminDetails((prevState) => ({
      //     ...prevState,
      //     is_email_verified: data?.is_email_verified,
      //     [item]:
      //       item == "company_name"
      //         ? data?.company_name
      //         : item == "name"
      //           ? data?.name
      //           : item == "email"
      //             ? data?.email
      //             : item == "password"
      //               ? data?.password
      //               : item == "location"
      //                 ? data?.location
      //                 : item == "logo"
      //                   ? data?.logo
      //                   : item == "role_id"
      //                     ? data?.role_id
      //                     : item == "phone"
      //                       ? data?.phone
      //                       : item == "id"
      //                         ? data?.id
      //                         : "",
      //   }));
      // });
      setEditMode(true);
      setPopup(type);
      setPopup(id);
      setLoading(false);
    }
    // console.log(res);
  };

  const getList = async (search) => {
    const formdata = new FormData();
    formdata.append("rows", 10);
    formdata.append("search", search ? search : "");
    formdata.append("order", "desc");
    formdata.append("page", page);
    setFullLoader(true);
    const res = await apiRequest(companyList, formdata);
    setFullLoader(false);
    if (res?.status == "success") {
      setList(res?.lists);
      setCount(res?.pagination_meta);
      setPagination(res?.pagination_meta);
    }
  };

  const getRolesList = async () => {
    const res = await apiRequest(companyRolesList);
    console.log(res, "roles");
    if (res?.status == "success") {
      setRoleslist(res?.role);
      setAdminDetails((prevState) => ({
        ...prevState,
        role_id: res?.role?.id ? res?.role?.id : "",
      }));
    }
  };
  const getLocationList = async () => {
    const res = await apiRequest(companyLocationList);
    if (res?.status == "success") {
      setLoclist(res?.data);
    }
  };

  useEffect(() => {
    if (givenpermissions?.includes("CAN-List-COMPANIES")) {
      getList();
    }
    getRolesList();
    getLocationList();
  }, []);

  // console.log(admindetails.role_id, "admindetails.role_id");

  const AdminAdd = async (id) => {
    if (
      !admindetails?.name ||
      !admindetails?.company_name ||
      !admindetails?.company_code ||
      !admindetails?.location ||
      // !selectedImage ||
      admindetails?.phone?.length < 8 ||
      !admindetails?.email ||
      !admindetails?.email.match(EMAIL)
    ) {
      setError(true);
      return;
    }
    // if (!editMode) {
    //     if (
    //         admindetails?.password.length < 10 ||
    //         admindetails?.password_confirmation?.length < 10 ||
    //         !admindetails?.password.match(PASS) ||
    //         admindetails?.password != admindetails?.password_confirmation
    //     ) {
    //         setError(true);
    //         return;
    //     }
    // }
    setError(false);
    const formdata = new FormData();
    formdata.append("name", admindetails?.name);
    formdata.append("company_name", admindetails?.company_name);
    formdata.append("company_code", admindetails?.company_code);
    formdata.append("email", admindetails?.email);
    formdata.append("roles", rolesList?.id);
    formdata.append("phone", admindetails?.phone);
    // if (admindetails?.password) {
    //   formdata.append("password", admindetails?.password);
    // }
    // if (admindetails?.password_confirmation) {
    //   formdata.append(
    //     "password_confirmation",
    //     admindetails?.password_confirmation
    //   );
    // }
    formdata.append("location", admindetails?.location);
    formdata.append("logo", selectedImage);
    formdata.append("profile_image", image);

    console.log("payload", formdata);
    setLoader(true);
    let res = {};
    if (editMode) {
      // if (emailCheckData?.id) {
      //   formdata.append("user_id", emailCheckData?.id);
      // }
      res = await apiRequest(updateAdmin, formdata, id);
    } else {
      res = await apiRequest(addCompany, formdata);
    }
    setLoader(false);
    if (res?.status == "success") {
      toast.success(res?.message);
      setPopup("");
      setAdminDetails({});
      setEditMode(false);
      getList();
      setEmailCheckFlag(0);
      setImage("");
      setSelectedImage("");
    } else if (res?.status == "error") {
      toast.error(res?.message);
    }
  };
  useEffect(() => {
    getList();
  }, [page]);
  // console.log(page);

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    setAdminDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Company Name",
        accessor: "company_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Primary Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return (
            <div>
              <p>{value}</p>
              <div className="d-flex ac-jc mt-2 gap-2">
                <img
                  src={row?.original?.is_email_verified ? green_icon : red_icon}
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {row?.original?.is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Number",
        accessor: "phone",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Location",
        accessor: "location",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Total Devices",
        accessor: "device_count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Daily Log",
        accessor: "Log",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  navigate("/daily-log");
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (givenpermissions?.includes("CAN-Status-COMPANIES")) {
                    handleStatus(row.original.id);
                  }
                }}
                className={`border-0 ms-2 cust-btn `}
              >
                {value == 1 ? (
                  <img
                    className={`toggle-btn ${
                      givenpermissions?.includes("CAN-Status-COMPANIES")
                        ? ""
                        : "opacity-25"
                    }`}
                    src={toggle_on}
                  />
                ) : (
                  <img
                    className={`toggle-btn ${
                      givenpermissions?.includes("CAN-Status-COMPANIES")
                        ? ""
                        : "opacity-25"
                    }`}
                    src={toggle_off}
                  />
                )}
              </button>
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {givenpermissions?.includes("CAN-View-COMPANIES") && (
                  <button
                    onClick={() => {
                      // companyListView(row.original.id, "view");
                      navigate("/user-list", {
                        state: { id: row?.original?.id },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
                {givenpermissions?.includes("CAN-Edit-COMPANIES") && (
                  <button
                    // onClick={() => {
                    //   setID(row?.original?.id);
                    //   companyListView(row.original.id, "edit");
                    // }}
                    onClick={() => {
                      navigate("/company-generate", {
                        state: { type: "edit", data: row.original },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
                {/* {givenpermissions?.includes("CAN-Delete-COMPANIES") && (
                                    <button
                                        onClick={() => setDeletePopup(row.original.id)}
                                        className="cust-btn "
                                    >
                                        <img src={delete_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                )} */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page],
  );

  const autoFetchData = (data) => {
    setFiedsetEnable(false);
    let emCheck = {
      ...data?.user,
      company: data?.company,
    };
    setEmailCheckData(emCheck);
    if (data?.company?.id) {
      setID(data?.company?.id);
    }
    let ob = {
      id: "",
      company_name: "",
      company_code: "",
      name: "",
      email: "",
      role_id: "",
      phone: "",
      password: "",
      password_confirmation: "",
      location: "",
      logo: "",
      email_verified: data?.id ? 1 : 0,
      is_email_verified: data?.is_email_verified,
    };

    if (data?.company?.id) {
      setEditMode(true);
    }

    if (data?.company?.logo) {
      setSelectedImage(data?.company?.logo);
    }

    if (data?.user?.profile_image) {
      setImage(data?.profile_image);
    }

    if (data?.company?.name) {
      ob.company_name = data?.company?.name;
    }

    if (data?.company?.company_code) {
      ob.company_code = data?.company?.company_code;
    }

    if (data?.company?.site?.address) {
      ob.address = data?.company?.site?.address;
    }
    if (data?.user?.role_id) {
      ob.role_id = data?.user?.role_id;
    }
    if (data?.company?.site?.location) {
      ob.location = data?.company?.site?.location;
    } else if (data?.company?.location) {
      ob.location = data?.company?.location;
    }

    if (data?.user?.phone) {
      ob.phone = data?.user?.phone;
    }

    if (data?.user?.name) {
      ob.name = data?.user?.name;
    }

    if (data?.company?.logo) {
      ob.logo = data?.company?.logo;
    }

    if (data?.user?.email) {
      ob.email = data?.user?.email;
    } else {
      ob.email = admindetails?.email;
    }

    setAdminDetails(ob);
  };

  const emailApi = async (formdata) => {
    try {
      const res = await post(ApiCall.EMAIL_CHECK, formdata);
      if (res?.status === "success") {
        const return_data = res;
        return return_data;
      }

      return {};
    } catch (err) {
      console.log("err", err);
      return {};
    }
  };

  const emailCheck = async () => {
    let formdata = new FormData();
    if (admindetails?.email?.length > 0) {
      formdata.append("email", admindetails?.email);
      if (editMode) {
        formdata.append("update", "update");
      }
      let res = await emailApi(formdata);
      if (res?.exists && editMode) {
        toast.error(res?.message);
      } else {
        setEmailCheckFlag(1);
        let data = res?.userData?.[0];
        if (res?.userData?.length > 0) {
          if (data?.user?.type == 3) {
            autoFetchData(data);
          } else if (data?.user?.type == null) {
            autoFetchData(data);
          } else {
            toast.error("Email ID already exists");
          }
        } else {
          let ob = {
            ...(editMode ? admindetails : admindetailsObj),
            email: admindetails.email,
          };
          console.log("ob", ob);

          setAdminDetails(ob);
          setEmailCheckData({});
          // setEditMode(false);
          if (!editMode) {
            toast("please enter all required fields");
          }
        }
      }
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  return (
    <div className="dashRightView home_section">
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.3)", // 👈 semi-transparent black
            zIndex: 1050, // above other elements
          }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
          Company List
        </h2>
        {givenpermissions?.includes("CAN-Add-COMPANIES") && (
          <button
            onClick={() => {
              navigate("/company-generate");
              // setPopup(true);
              // setError(false);
              // setID("");
            }}
            className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
          >
            {" "}
            + Add Company
          </button>
        )}
      </div>

      <div className="d-flex ac-jb my-3 ">
        <div className="d-flex">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  mb-0 ">
            Total Count :
          </h4>
          <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-0 ms-2">
            {count?.total}
          </h4>
        </div>
        <div className="d-flex">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  me-3 mb-0 ms-3 mt-2">
            Search
          </h4>
          <input
            type="text"
            className="input-pop ps-2"
            placeholder=" Search"
            onChange={(e) => {
              getList(e.target.value);
            }}
          />
        </div>
      </div>
      {popup && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                {editMode ? "Edit Company" : "Add Company"}
              </h2>
              <button
                onClick={() => {
                  if (editMode) {
                    setEditMode(false);
                  }
                  setPopup("");
                  setSelectedImage("");
                  setAdminDetails({});
                  setID("");
                  setEmailCheckFlag(0);
                  setSelectedImage("");
                  setImage("");
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Primary Email ID<span className="text-danger">*</span>
            </h4>
            <div className="d-flex">
              <input
                type="email"
                className={`input-pop ps-2 w-100`}
                placeholder=" Email Address"
                name="email"
                onChange={(e) => {
                  // handleUpdate(e);
                  if (editMode) {
                    setAdminDetails(() => ({
                      ...admindetails,
                      email: e.target.value,
                    }));
                  } else {
                    setEmailCheckFlag(0);
                    setSelectedImage("");
                    setImage("");
                    setAdminDetails(() => ({
                      ...admindetailsObj,
                      email: e.target.value,
                    }));
                  }
                }}
                value={admindetails?.email}
                // disabled={popup == "view" || popup == "edit" ? true : false}
                disabled={popup == "view"}
              />
              <button
                className={`email_check_btn ${
                  admindetails?.email?.length > 2 ? "" : "opacity-50"
                }`}
                disabled={
                  admindetails?.email?.length == 0
                    ? true
                    : // : popup == "view" || popup == "edit"
                      popup == "view"
                      ? true
                      : false
                }
                onClick={() => emailCheck()}
              >
                Check
              </button>
            </div>
            {id && (
              <div className="d-flex ac-je mt-2 gap-2">
                <img
                  src={admindetails?.is_email_verified ? green_icon : red_icon}
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {admindetails?.is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            )}
            {error &&
              (!admindetails?.email || !admindetails?.email.match(EMAIL)) && (
                <p className="err">Enter Valid Email</p>
              )}
            {/* <fieldset disabled={fieldsetEnable}> */}
            {emailCheckFlag == 1 && (
              <>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Company Name<span className="text-danger">*</span>
                </h4>
                <input
                  type="text"
                  className={`input-pop ps-2 w-100 ${
                    emailCheckFlag == 0 ? "opacity-50" : ""
                  }`}
                  placeholder="Company Name"
                  name="company_name"
                  onChange={(e) => {
                    handleUpdate(e);
                  }}
                  value={admindetails?.company_name}
                  disabled={
                    popup == "view"
                      ? true
                      : emailCheckData?.company?.name
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                  }
                />
                {error && !admindetails?.company_name && (
                  <p className="err">Enter Your Name</p>
                )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Company Code<span className="text-danger">*</span>
                </h4>
                <input
                  type="text"
                  className={`input-pop ps-2 w-100 ${
                    emailCheckFlag == 0 ? "opacity-50" : ""
                  }`}
                  placeholder="Company Code"
                  name="company_code"
                  onChange={(e) => {
                    handleUpdate(e);
                  }}
                  value={admindetails?.company_code}
                  disabled={
                    popup == "view"
                      ? true
                      : emailCheckData?.company?.company_code
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                  }
                />
                {error && !admindetails?.company_code && (
                  <p className="err">Enter Company Code</p>
                )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Primary Person Name<span className="text-danger">*</span>
                </h4>
                <input
                  type="text"
                  className={`input-pop ps-2 w-100 ${
                    emailCheckFlag == 0 ? "opacity-50" : ""
                  }`}
                  placeholder="Primary Person Name"
                  name="name"
                  onChange={(e) => {
                    handleUpdate(e);
                  }}
                  value={admindetails?.name}
                  disabled={
                    popup == "view"
                      ? true
                      : emailCheckData?.name
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                  }
                />
                {error && !admindetails?.name && (
                  <p className="err">Enter Primary Person Name</p>
                )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Primary Mobile Number(Singapore)
                  <span className="text-danger">*</span>
                </h4>
                <input
                  type="number"
                  className={`input-pop ps-2 w-100 ${
                    emailCheckFlag == 0 ? "opacity-50" : ""
                  }`}
                  placeholder="Primary Mobile Number(Singapore)"
                  name="phone"
                  onChange={(e) => {
                    if (e.target.value?.length <= 8) {
                      handleUpdate(e);
                    }
                  }}
                  value={admindetails?.phone}
                  disabled={
                    popup == "view"
                      ? true
                      : emailCheckData?.phone
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                  }
                />
                {error && admindetails?.phone?.length < 8 && (
                  <p className="err">Enter Valid Phone Number(Singapore)</p>
                )}

                {/* {popup != "view" && (
              <div>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Password
                </h4>
                <div className="input-pop mb-2 w-100 d-flex ac-jb">
                  <input
                    type={visible ? "text" : "password"}
                    maxLength={20}
                    className="cust-btn  w-90"
                    placeholder="Password"
                    name="password"
                    autoComplete="off"
                    onChange={(e) => {
                      handleUpdate(e);
                    }}
                    value={admindetails?.password}
                    disabled={emailCheckData?.company?.id ? true : false}
                  />
                  <img
                    src={eye_icon}
                    onClick={() => setVisible(!visible)}
                    className="eye-icon pointer"
                    alt=""
                  />
                </div>
                {error &&
                  !editMode &&
                  (admindetails?.password?.length < 8 ||
                    !admindetails?.password?.match(PASS)) && (
                    <p className="err">
                      {!admindetails?.password
                        ? "Enter Your password"
                        : !admindetails?.password?.match(PASS)
                        ? "Must include one special char & capital leteer"
                        : "Enter Minimum 8 Charactors"}
                    </p>
                  )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Confirm Password
                </h4>
                <div className="input-pop mb-2 w-100 d-flex ac-jb">
                  <input
                    type={visible ? "text" : "password"}
                    maxLength={20}
                    className="cust-btn w-90"
                    placeholder=" Confirm Password"
                    name="password_confirmation"
                    autoComplete="off"
                    onChange={(e) => {
                      handleUpdate(e);
                    }}
                    value={admindetails?.password_confirmation}
                    disabled={emailCheckData?.company?.id ? true : false}
                  />
                  <img
                    src={eye_icon}
                    onClick={() => setVisible(!visible)}
                    className="eye-icon pointer"
                    alt=""
                  />
                </div>
                {error &&
                  !editMode &&
                  (admindetails?.password_confirmation?.length < 8 ||
                    admindetails?.password !=
                      admindetails?.password_confirmation) && (
                    <p className="err">
                      {!admindetails?.password_confirmation
                        ? "Enter Confirm Password"
                        : admindetails?.password_confirmation?.length < 8
                        ? "Enter Minimum 8 Charactors"
                        : "Password Mismatch"}
                    </p>
                  )}
              </div>
            )} */}

                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Roles<span className="text-danger">*</span>
                </h4>

                <input
                  name="role_id"
                  readOnly
                  value={rolesList?.name}
                  className={`input-pop ps-2 w-100 ${
                    emailCheckFlag == 0 ? "opacity-50" : ""
                  }`}
                />
                {/* {error && !admindetails?.role_id && (
                            <p className="err">Select Your Role</p>
                        )} */}

                <div>
                  <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                    Location<span className="text-danger">*</span>
                  </h4>
                  <select
                    name="location"
                    value={admindetails?.location}
                    onChange={(e) => {
                      handleUpdate(e);
                    }}
                    className={`input-pop ps-2 w-100 ${
                      emailCheckFlag == 0 ? "opacity-50" : ""
                    }`}
                    disabled={
                      emailCheckData?.company?.location
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                    }
                  >
                    <option>Select Location</option>
                    {locList.map((item) => {
                      return (
                        <option value={item?.id} key={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                  {error && !admindetails?.location && (
                    <p className="err">Enter Your Location </p>
                  )}
                  <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex ac-js gap-1">
                    Company Logo Upload{" "}
                    <span className="text-danger fs-12">
                      JPG, JPEG, PNG only | Max size: 5MB
                    </span>
                  </h4>
                  <div
                    className={`input-pop mb-2 w-100 d-flex ac-jb ${
                      emailCheckFlag == 0 ? "opacity-50" : ""
                    }`}
                  >
                    <div
                      onClick={() => {
                        if (!emailCheckData?.company?.logo) {
                          if (emailCheckFlag == 1) {
                            handleImageClick();
                          }
                        }
                      }}
                      className="position-relative w-100"
                    >
                      <div className="d-flex ac-jb w-100">
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
                          Choose Upload Image
                        </h4>
                        <div>
                          {typeof selectedImage === "string" ? (
                            <img
                              alt="not found"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                              }}
                              src={selectedImage ? selectedImage : dummyimage}
                            />
                          ) : selectedImage?.name ? (
                            <img
                              alt="not found"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                              }}
                              src={URL.createObjectURL(selectedImage)}
                            />
                          ) : (
                            <img
                              alt="not found"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                              }}
                              src={dummyimage}
                            />
                          )}
                          <input
                            style={{
                              position: "absolute",
                              width: "40px",
                              height: "40px",
                              left: "0px",
                              top: "0px",
                            }}
                            type="file"
                            hidden
                            name="logo"
                            accept="image/*"
                            ref={inputRef}
                            onChange={handleImageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {error && !selectedImage && (
                    <p className="err">Upload Logo </p>
                  )} */}
                  <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex ac-js gap-1">
                    Profile Image Upload{" "}
                    <span className="text-danger fs-12">
                      JPG, JPEG, PNG only | Max size: 5MB
                    </span>
                  </h4>
                  <div
                    className={`input-pop mb-2 w-100 d-flex ac-jb ${
                      emailCheckFlag == 0 ? "opacity-50" : ""
                    }`}
                  >
                    <div
                      onClick={() => {
                        if (!emailCheckData?.profile_url) {
                          if (emailCheckFlag == 1) {
                            handleImageClickPro();
                          }
                        }
                      }}
                      className="position-relative w-100"
                    >
                      <div className="d-flex ac-jb w-100">
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
                          Choose Upload Image
                        </h4>
                        <div>
                          {typeof image === "string" ? (
                            <img
                              alt="not found"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                              }}
                              src={image ? image : dummyimage}
                            />
                          ) : image?.name ? (
                            <img
                              alt="not found"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                              }}
                              src={URL.createObjectURL(image)}
                            />
                          ) : (
                            <img
                              alt="not found"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                              }}
                              src={dummyimage}
                            />
                          )}
                          <input
                            style={{
                              position: "absolute",
                              width: "40px",
                              height: "40px",
                              left: "0px",
                              top: "0px",
                            }}
                            type="file"
                            hidden
                            name="logo"
                            accept="image/*"
                            ref={inputRefImg}
                            onChange={handleImageChangePro}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {error && !selectedImage && (
                    <p className="err">Upload Logo </p>
                  )} */}
                </div>
                {/* </fieldset> */}

                {popup != "view" && (
                  <div className="d-flex ac-jc">
                    {emailCheckData?.id ? (
                      <button
                        onClick={() => {
                          AdminAdd(id);
                        }}
                        // disabled={
                        //   emailCheckData?.email == admindetails?.email
                        //     ? false
                        //     : true
                        // }
                        className={`login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 
                      ${
                        emailCheckData?.email == admindetails?.email
                          ? ""
                          : // : "opacity-50"
                            ""
                      }
                      `}
                      >
                        {loader && (
                          <div
                            class="spinner-border spinner-border-sm "
                            role="status"
                            style={{ marginRight: "5px" }}
                          ></div>
                        )}
                        Submit
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          AdminAdd(id);
                        }}
                        className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                      >
                        {loader && (
                          <div
                            class="spinner-border spinner-border-sm "
                            role="status"
                            style={{ marginRight: "5px" }}
                          ></div>
                        )}
                        Submit
                      </button>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
          {/* </div> */}
        </div>
      )}
      {deletePopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setDeletePopup("")} className="no-btn">
                No
              </button>
              <button
                onClick={() => {
                  handleDelete(deletePopup);
                  setDeletePopup(false);
                }}
                className="yes-btn f2"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      {fullLoader ? (
        <CommonLoader />
      ) : (
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list}
          show={true}
        />
      )}
    </div>
  );
};
export default Company;
